import * as React from 'react'

import useIncidenceFilters, {
  DefaultParams,
  UseIncidenceFilterReturn,
} from 'modules/bookkeepers/hooks/useIncidenceFilters'

const IncidenceFilterContext = React.createContext<UseIncidenceFilterReturn | null>(null)

interface IncidenceFilterProviderProps {
  defaultFilterValues: DefaultParams
}

export const IncidenceFilterProvider = ({
  defaultFilterValues,
  children,
}: React.PropsWithChildren<IncidenceFilterProviderProps>) => {
  const filters = useIncidenceFilters(defaultFilterValues)

  return (
    <IncidenceFilterContext.Provider value={filters}>{children}</IncidenceFilterContext.Provider>
  )
}

export const useIncidenceFilterContext = (): UseIncidenceFilterReturn => {
  const filters = React.useContext(IncidenceFilterContext)

  if (!filters) {
    throw new Error('useIncidenceFilterContext must be used within a IncidenceFilterProvider')
  }

  return filters
}
